import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { canAccessGuard } from '../../_core/guards/can-access.guard';
import { featureFlagGuard } from '../../_core/guards/feature-flag.guard';
import { FeatureFlagKeys } from '../../_core/models/FeatureFlags';
import { DistributionComponent } from './distribution/distribution.component';

const routes: Routes = [
  {
    path: '',
    component: DistributionComponent,
    canActivate: [canAccessGuard],
  },
  {
    path: 'manage-recurring',
    loadComponent: () =>
      import('./manage-recurring/manage-recurring.component').then(
        (m) => m.ManageRecurringComponent
      ),
    canMatch: [featureFlagGuard],
    data: { featureFlagKey: FeatureFlagKeys.RecurringDistributions },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DistributionRoutingModule {}
